<template>
  <el-dialog
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      :title="$t('palletReceipt.absentPallets')"
      :visible.sync="dialogVisible"
      width="34%"
      id="print-absent-pallet-receipts-dialog"
      v-on:closed="$emit('close-dialog')">
    <el-form :model="searchForm" :rules="formRules" ref="searchForm" label-position="right" size="mini" inline
             class="text-align-end">
      <el-row>
        <el-col class="form-vertical-item">
          <el-form-item :label="$t('palletReceipt.warehouse')">
            <el-input
                v-model="user.warehouseCode"
                ref="filter-layout-template"
                disabled
                class="inline-input"
                id="searchForm-warehouse"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col class="form-vertical-item">
          <el-form-item :label="$t('palletReceipt.dayOfService')" prop="shipDate">
            <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="searchForm.shipDate"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
                id="searchForm-date-of-service-from"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="form-vertical-item">
          <el-form-item :label="$t('palletReceipt.shipper')">
            <autocomplete
                :model.sync="searchForm.shipperAccountId"
                :shipperAccountId="null"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="urlShipper"
                labelField="name"
                valueField="id"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close-dialog')" size="mini">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handlePrint" size="mini" class="margin-r-18" id="btn-print">
        {{ $t('palletReceipt.print') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  components: {
    Autocomplete
  },
  computed: {
    ...mapGetters([
      'palletReceipt',
      'user'
    ]),
    urlShipper() {
      return apiConstants.END_POINTS.ACCOUNTS.SHIPPERS;
    },
  },
  props: ['displayDialog'],
  data() {
    return {
      dialogVisible: this.displayDialog,
      searchForm: {
        shipDate: null,
        shipperAccountId: null
      },
      formRules: {
        shipDate: [
          {
            required: true,
            message: this.$t('palletReceipt.error.dateFromRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  watch: {
    displayDialog(newValue) {
      this.dialogVisible = newValue;
    }
  },
  methods: {
    handleOpen() {
      this.searchForm.shipDate = this.palletReceipt.actualFilters.dayOfServiceFrom || new Date();
    },
    async handlePrint() {
      const loading = Loading.service(constants.LOADING.PRINT_PALLET_RECEIPT_CONFIG);
      const validForm = await this.$refs.searchForm.validate()
        .catch(() => {
        });
      if (validForm) {
        await this.$store.dispatch('palletReceipt/printAbsentPallets', this.searchForm);
      }
      loading.close();
    }
  }
};
</script>
